import { Component } from '@angular/core';

@Component({
  selector: 'app-project-settings',
  standalone: true,
  imports: [],
  templateUrl: './project-settings.component.html',
  styleUrl: './project-settings.component.scss'
})
export class ProjectSettingsComponent {

}
